import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BehaviorSubject, Subscription, Subscriber } from 'rxjs';
import { SettingsService, DEFAULT_LANGUAGE } from '../settings/settings.service';

@Injectable()
export class TranslatorService {

    public readonly availableLangs = new BehaviorSubject<{ code: string, text: string }[]>([]);

    constructor(
        private settings: SettingsService,
        private translate: TranslateService
    ) {
        if (!translate.getDefaultLang()) {
            translate.setDefaultLang(DEFAULT_LANGUAGE);
        }

        this.refreshAvailableLangs();
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            // console.warn("TRANSLATOR LANG CHANGED: "); console.warn(event);
            sessionStorage.setItem("lang", event.lang);
            this.refreshAvailableLangs();
        });
    }

    private refreshAvailableLangs() {
        this.availableLangs.next([
            { code: 'en', text: this.translate.instant("lang.en") },
            { code: 'hu', text: this.translate.instant("lang.hu") }
        ]);
    }

    useLanguage(lang: string = null): string {
        lang = lang || this.settings.getUserSetting("lang") || sessionStorage.getItem("lang") || this.translate.getBrowserLang();
        this.translate.use(lang);
        return lang;
    }

}
